var _circle, _circle2, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#263159"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_973_28969",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#263159"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_973_28969)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.05,
    y: 17.05,
    width: 38.9,
    height: 49.9,
    fill: "white",
    stroke: "#73788C",
    strokeWidth: 0.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 56,
    width: 33,
    height: 2,
    rx: 1,
    fill: "#D1D6E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 25,
    width: 32,
    height: 2,
    rx: 1,
    fill: "#D1D6E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 33,
    width: 33,
    height: 2,
    rx: 1,
    fill: "#D1D6E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 41,
    width: 33,
    height: 2,
    rx: 1,
    fill: "#D1D6E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 45,
    width: 34,
    height: 2,
    rx: 1,
    fill: "#D1D6E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 33,
    width: 12,
    height: 2,
    rx: 1,
    fill: "#D1D6E1"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_973_28969)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 13,
    width: 39,
    height: 50,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.05,
    y: 13.05,
    width: 38.9,
    height: 49.9,
    stroke: "#73788C",
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 25,
    width: 26,
    height: 2,
    rx: 1,
    fill: "#D1D6E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 29,
    width: 29,
    height: 2,
    rx: 1,
    fill: "#D1D6E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 33,
    width: 30,
    height: 2,
    rx: 1,
    fill: "#D1D6E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 41,
    width: 31,
    height: 2,
    rx: 1,
    fill: "#D1D6E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 45,
    width: 25,
    height: 2,
    rx: 1,
    fill: "#D1D6E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 53,
    width: 25,
    height: 2,
    rx: 1,
    fill: "#D1D6E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 57,
    width: 25,
    height: 2,
    rx: 1,
    fill: "#D1D6E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 49,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#D1D6E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 37,
    width: 28,
    height: 2,
    rx: 1,
    fill: "#D1D6E1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 18,
    width: 24,
    height: 3,
    rx: 1.5,
    fill: "#73788C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_973_28969",
    x: 5,
    y: 13,
    width: 47,
    height: 58,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_973_28969"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_973_28969",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfAvatar);
export default __webpack_public_path__ + "static/media/pdf-avatar.18736418426bcbf62f2db4f8194496d0.svg";
export { ForwardRef as ReactComponent };